import cloneDeep from 'lodash/cloneDeep.js';
import get from 'lodash/get.js';

const updateCourseField = async (store, mutation) => {
    const course = cloneDeep(store.getters['CourseTemplateForm/course']);

    store.commit(
        'BulkEditor/SET_COURSE_KEY_ENABLED',
        get(course, 'course_settings.course_key_enabled', get(course, 'course_settings_template.course_key_enabled'))
    );

    if (!course.title || !course.course_type_id || !course.description) return;

    await store.dispatch('AutoSave/setSaving', mutation);

    await store.dispatch('AutoSave/courseForm', {
        mutation: mutation.type,
        course,
    });

    store.dispatch('AutoSave/setSaved', mutation);
};

export default {
    'CourseTemplateForm/updateCourseField': {
        fields: [
            'title',
            'description',
            'course_type_id',
            'external_id',
            'course_settings_template.course_key_enabled',
            'course_settings.course_key_enabled',
            'course_settings.exxat_course_id',
            'course_settings_template.has_flexible_attendance',
            'course_settings.has_flexible_attendance',
            'course_settings_template.expected_scheduled_time',
            'course_settings.expected_scheduled_time',
            'course_settings_template.attendance_scenario_id',
            'course_settings.attendance_scenario_id',
            'course_settings.is_pass_or_fail',
            'course_settings_template.is_pass_or_fail',
            'course_settings.course_authorized_role_id',
            'course_settings_template.course_authorized_role_id',
            'course_settings_template.show_student_enrollments',
            'course_settings.show_student_enrollments',
            'course_settings_template.permit_extra_credit_overflow',
            'course_settings.permit_extra_credit_overflow',
        ],
        callback: updateCourseField,
    },

    'CourseTemplateForm/toggleCourseKey': {
        fields: ['course_settings_template.course_key_enabled', 'course_settings.course_key_enabled'],
        callback: updateCourseField,
    },

    'CourseTemplateForm/setExxatCourseId': {
        fields: ['course_settings.exxat_course_id'],
        callback: updateCourseField,
    },

    'CourseTemplateForm/autoSaveOrder': {
        fields: ['save'],
        callback: async (store, mutation) => {
            try {
                await store.dispatch('AutoSave/setSaving', mutation);

                await store.dispatch('AutoSave/updateOrder', {
                    items: mutation.payload.items,
                    mutation: mutation.type,
                });

                store.dispatch('AutoSave/setSaved', mutation);
            } catch (error) {
                const isWeekBreakValidationError =
                    error.response?.status === 422 &&
                    error.response?.data?.message?.includes('Week and Break sections cannot be nested');

                if (isWeekBreakValidationError) {
                    throw error;
                } else {
                    store.dispatch('AutoSave/setError', { indicator: mutation, error });
                }
            }
        },
    },
};
